import React from "react";
import ReactToPrint from "react-to-print";

import AppComponent from "../../Components/AppComponent";
import { Table, Button } from "react-bootstrap";
import ScrollListener from "../../Components/eventListeners/ScrollListener";
import WindowScrollListener from "../../Components/eventListeners/WindowScrollListener";

class ItemList extends AppComponent {
  state = {
    error: null,
    loading: true,
  };

  componentRef = React.createRef(null);

  defaultQuery = {
    sortby: "createdAt",
    order: -1,
    limit: 100,
    ...(this.props.defaultQuery || {}),
  };

  query = { ...this.defaultQuery, ...(this.props.query || {}) };

  componentDidMount() {
    this.onMount();
    this.load(this.query);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.triggerReload !== this.props.triggerReload) {
      this.load(this.query);
    } else if (prevProps.triggerLoadMore !== this.props.triggerLoadMore) {
      this.loadMore();
    }
  }

  elRef = React.createRef(null);

  reactToPrintTrigger = () => {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button size="sm" variant="secondary">
          Print
        </Button>
      </div>
    );
  };

  render() {
    const {
      props: { items },
      state: { loading = false },
    } = this;

    return (
      <>
        {this.componentRef.current ? (
          <ReactToPrint
            content={() => this.componentRef.current}
            documentTitle={`tn-list`}
            // onAfterPrint={this.handleAfterPrint}
            // onBeforeGetContent={this.handleOnBeforeGetContent}
            // onBeforePrint={this.handleBeforePrint}
            removeAfterPrint
            trigger={this.reactToPrintTrigger}
          />
        ) : null}

        <div className="itemlist" ref={this.componentRef}>
          {this.state.error ? (
            <div className="errormsg">{this.state.error}</div>
          ) : null}

          {loading ? (
            <div className="barloader">
              <div className="bar" />
            </div>
          ) : null}

          {this.props.renderTable ? (
            this.props.renderTable({ items })
          ) : (
            <RenderTable {...this.props} />
          )}

          {!items?.length && !loading ? (
            <div className="nothingbox nothingpadded">
              <div className="nothingdecor">
                <div className="nothing one"></div>
                <div className="nothing two"></div>
              </div>
              <div className="nothingline">Nothing to show here</div>
            </div>
          ) : null}

          {items.length && loading ? (
            <div className="barloader">
              <div className="bar" />
            </div>
          ) : null}
        </div>

        {this.props.scrollSelector ? (
          <ScrollListener
            onWindowScroll={console.log}
            onScrollEnd={this.loadMore.bind(this)}
            // elRef={this.elRef}
            scrollSelector={this.props.scrollSelector || ""}
          />
        ) : (
          <WindowScrollListener
            onWindowScroll={console.log}
            onScrollEnd={this.loadMore.bind(this)}
          />
        )}
      </>
    );
  }

  loadMore() {
    const {
      props: { items, disablePagination },
      state: { loading },
    } = this;

    if (disablePagination) return null;

    if (loading) return null;

    let query = { ...this.query };
    let andQuery;

    if (query.where?.$and) {
      andQuery = query.where.$and;
    } else {
      andQuery = [query.where || {}];
    }

    if (items?.length) {
      let lastItem = items[items.length - 1];

      if (lastItem) {
        andQuery.push({
          _id: { $ne: lastItem._id },
        });
        andQuery.push({
          [query.sortby || "createdAt"]: {
            [query.order === -1 ? "$lte" : "$gte"]: lastItem[
              query.sortby || "createdAt"
            ],
          },
        });
      }
    }

    query = {
      ...query,
      where: {
        ...(query.where || {}),
        $and: andQuery,
      },
    };

    // console.log(query, this.query, this.defaultQuery, items);
    this.load(query, false);
  }

  loadThrottleTimer = null;
  async load(query, reload) {
    clearTimeout(this.loadThrottleTimer);
    this.loadThrottleTimer = setTimeout(() => {
      this.retrieveData(query, reload);
    }, 200);
  }

  async retrieveData(query, reload = true) {
    this.setAsyncState({ loading: true, error: null });
    try {
      const {
        props: { additionalQueries },
      } = this;

      if (additionalQueries) {
        query = {
          ...(query || {}),
          ...(additionalQueries || {}),
          where: {
            ...(query?.where || {}),
            ...(additionalQueries?.where || {}),
            $and: [
              {},
              ...(query?.where?.$and || []),
              ...(additionalQueries?.where?.$and || []),
            ],
          },
        };
      }

      const items = await this.props.retriveData({
        queryStr: JSON.stringify(query),
      });

      if (reload) {
        this.props.setItems(items);
      } else {
        this.props.setItems([...(this.props.items || []), ...(items || [])]);
      }
    } catch (e) {
      console.warn(e);
      await this.setAsyncState({ error: e.message });
    }
    this.setAsyncState({ loading: false });
  }
}

class ItemRow extends AppComponent {
  render() {
    const {
      props: { item, index, table = {} },
    } = this;

    if (!item) return null;

    return (
      <>
        <tr
          onClick={() => table?.onRowClick?.({ item, index })}
          className={`${table?.onRowClick ? "pointer" : ""}`}
        >
          {table.columns?.map((col) => {
            return (
              <td key={col.value}>
                {col.render ? col.render({ item, index }) : item[col.value]}
              </td>
            );
          })}
        </tr>
      </>
    );
  }
}

class RenderTable extends React.PureComponent {
  render() {
    const {
      props: { items, table = {} },
    } = this;

    return (
      <div className="tablewrapper">
        <Table
          ref={this.componentRef}
          className="itemstable"
          striped
          hover
          bordered
        >
          <tbody>
            <tr>
              {table.columns?.map((x) => (
                <th key={x.value}>{x.label}</th>
              ))}
            </tr>

            {items?.map((item, index) => (
              <ItemRow key={item._id} item={item} index={index} table={table} />
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default ItemList;
